var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconHiking = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.935 4.033a2.033 2.033 0 1 0-4.065 0 2.033 2.033 0 0 0 4.065 0zm-6.416 3.294a1.017 1.017 0 0 0-.986-1.262h-.178A3.384 3.384 0 0 0 6.09 8.564l-1.054 3.87c-.157.58.22 1.173.813 1.27l2.028.34a1.013 1.013 0 0 0 1.152-.759l1.49-5.958zM21 9.792c0-.564-.453-1.017-1.016-1.017-.564 0-1.017.453-1.017 1.017v1.016h-1.151L16.6 8.983a3.272 3.272 0 0 0-2.054-1.393 2.535 2.535 0 0 0-3.002 1.914l-.838 3.663a2.363 2.363 0 0 0 .779 2.337l3.417 2.888v4.273c0 .563.453 1.016 1.016 1.016.564 0 1.017-.453 1.017-1.016v-4.43c0-.5-.22-.97-.602-1.291l-1.164-.983.949-4.03.105.156c.314.47.843.754 1.41.754h1.334v9.824c0 .563.453 1.016 1.017 1.016.563 0 1.016-.453 1.016-1.016V9.792zm-6.877-.216c.152.034.296.093.423.173l-1.113 4.739-.631-.534a.334.334 0 0 1-.11-.334l.838-3.663a.506.506 0 0 1 .597-.381h-.004zM8.165 22.39c-.152.542.16 1.1.703 1.253a1.014 1.014 0 0 0 1.253-.703l1.554-5.505-1.05-.89a3.683 3.683 0 0 1-.618-.668L8.165 22.39z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHiking, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-hiking.3963b1cd.svg";
export { ForwardRef as ReactComponent };